export default "__VITE_ASSET__BlTn7QdK__"